// General content and company information

export const companyInfo = {
    name: 'S.N Enterprises',
    tagline: 'Authorized Super Platinum Dealer of Astral Pipes',
    description: 'Your trusted partner for premium Astral pipe products. We supply genuine CPVC, UPVC, SWR pipes, water tanks, and fittings with competitive dealer pricing and reliable delivery.',

    contact: {
        phone: '+91 9844552994',
        whatsapp: '919844552994',
        email: 'snpipes2020@gmail.com',
        address: 'GROUND FLOOR, SHOP SITE NO 118, SY. NO 148 MAIN ROAD KUDUKU VILLAGE, SARJAPURA HOBLI, KSRP AMRUTHA COLLEGE, Kammasandra Anekal Taluka, BANGALORE, Bengaluru Urban, Karnataka - 560100',
        gstin: '29ADNPU0612J1Z7',
        state: 'Karnataka',
        stateCode: '29',
    },

    hours: {
        weekdays: 'Monday - Saturday: 9:00 AM - 6:00 PM',
        weekend: 'Sunday: Closed',
    },

    established: '2020',
    experience: '6+ years',
};

export const services = [
    {
        id: 'bulk-supply',
        title: 'Bulk Contractor Supply',
        description: 'Large-scale supply of Astral pipes and fittings for construction contractors with competitive bulk pricing and flexible delivery schedules.',
        icon: 'Truck',
    },
    {
        id: 'retail-wholesale',
        title: 'Retail & Wholesale Sales',
        description: 'Best dealer prices for retailers and wholesalers. Stock a complete range of Astral products with reliable restocking support.',
        icon: 'Store',
    },
    {
        id: 'industrial-supply',
        title: 'Industrial Pipe Supply',
        description: 'Specialized industrial-grade pipes for factories, plants, and commercial establishments. Technical support available.',
        icon: 'Factory',
    },
    {
        id: 'delivery',
        title: 'Fast Delivery Service',
        description: 'Prompt delivery across the region. Same-day dispatch for in-stock items. Transportation support for bulk orders.',
        icon: 'Zap',
    },
    {
        id: 'consultation',
        title: 'Product Selection Guidance',
        description: 'Expert consultation to help you choose the right pipe type, size, and specifications for your specific application needs.',
        icon: 'MessageCircle',
    },
];

export const whyChooseUs = [
    {
        id: 'authorized',
        title: 'Authorized Astral Dealer',
        description: '100% genuine Astral products directly from authorized sources',
        icon: 'BadgeCheck',
    },
    {
        id: 'quality',
        title: 'Quality Assurance',
        description: 'All products are ISI certified and meet industry standards',
        icon: 'Award',
    },
    {
        id: 'pricing',
        title: 'Best Dealer Pricing',
        description: 'Competitive prices for bulk and retail purchases',
        icon: 'DollarSign',
    },
    {
        id: 'delivery',
        title: 'Fast & Reliable Delivery',
        description: 'Quick dispatch and on-time delivery guaranteed',
        icon: 'Truck',
    },
    {
        id: 'experience',
        title: '6+ Years Experience',
        description: 'Trusted by contractors, builders, and retailers since 2020',
        icon: 'Star',
    },
    {
        id: 'support',
        title: '24/7 Customer Support',
        description: 'Expert assistance for product selection and technical queries',
        icon: 'Headphones',
    },
];

export const aboutContent = {
    story: `S.N Enterprises has been a leading authorized dealer of Astral Pipes since 2020. Based in Bangalore, we have built a reputation for supplying genuine, high-quality products at competitive prices.

Our commitment to excellence and customer satisfaction has made us the preferred choice for contractors, builders, architects, and retailers across Karnataka. We understand the critical importance of reliable piping systems in construction and infrastructure projects.

From small residential requirements to large-scale commercial and industrial projects, S.N Enterprises delivers consistent quality, timely service, and expert guidance.`,

    mission: 'To provide genuine Astral pipe products with exceptional service, competitive pricing, and reliable delivery, building long-term partnerships with our customers.',

    values: [
        {
            title: 'Trust',
            description: 'Building lasting relationships through authenticity and reliability',
        },
        {
            title: 'Quality',
            description: 'Uncompromising commitment to genuine, certified products',
        },
        {
            title: 'Reliability',
            description: 'Consistent delivery and dependable service every time',
        },
        {
            title: 'Excellence',
            description: 'Continuous improvement in service and customer satisfaction',
        },
    ],
};
